export default __webpack_public_path__ + "static/Economic Model Whitepaper - Chinese-bb86afa42d4d30a2cd6001f6e44c4160.pdf";